export var connvertFrmPartnerResponseIntoEntity = function (response) {
    var frmPartnersListdetails = {
        partners: [],
        filterData: [],
    };
    if (response.data)
        response.data.map(function (partner) {
            frmPartnersListdetails.filterData.push({
                id: partner.partnerid,
                name: partner.partner_name,
            });
            frmPartnersListdetails.partners.push({
                partnerId: partner.partnerid,
                partnerCode: partner.partner_code,
                partnerName: partner.partner_name,
                partnerType: partner.partner_type,
                empCode: partner.emp_code,
                empId: partner.emp_id,
                upcCode: partner.upccode,
                upcId: partner.upcid
            });
        });
    return frmPartnersListdetails;
};
